import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../../servicio/ServicioConstantes';
import servicioObjetos from '../../servicio/ServicioObjetos';
import ServicioHttp from '../../servicio/ServicioHttp';
import servicioFormatos from '../../servicio/ServicioFormatos';
import servicioArchivos from '../../servicio/ServicioArchivos';

const JOIN_INICIAL = {
    "tcTrabajador": "alias_tcTrabajador",
    "ttLoteSolicitudIdse": "alias_ttLoteSolicitudIdse",
    "alias_ttLoteSolicitudIdse.tcEmpresa": "alias_tcEmpresa",
    "alias_ttLoteSolicitudIdse.ttUsuario": "alias_ttUsuario"
}

const PAGINACION_INICIAL = {
    registrosPorPagina: 50,
    numeroPagina: 0,
    join: JOIN_INICIAL,
    restriccionesDinamicas: [],
    datos: []
};

export const DetalleMovimientosCliente = (props) => {

    const [fechaIncial, setFechaIncial] = useState(null);
    const [fechaFinal, setFechaFinal] = useState(null);
    const [errores, setErrores] = useState({});
    const [paginacion, setPaginacion] = useState(PAGINACION_INICIAL);
    const [inicio, setInicio] = useState(0);
    const [usuarios, setUsuarios] = useState([]);
    const { elCliente } = props;
        
    useEffect(() => {
        ServicioHttp.consumirPostHttp('/admin/usuario/obtener_subusuarios.json', { id: elCliente.id }).then(response => {
            setUsuarios(response.data.lista);
        }).catch(error => {
            setUsuarios([]);
        });
    }, [elCliente]);

    const buscarDetalle = () => {
        let errores = validarFormulario();
        setErrores(errores);
        if (servicioObjetos.esObjetoVacio(errores)) {
            paginacion.numeroPagina = 0;
            setInicio(0);
            asignarRestricciones();
            realizarBusquedaHttp();
        }
    }

    const realizarBusquedaHttp = () => {
        ServicioHttp.consumirPostHttp('movimientos/consultar.json', paginacion).then(response => {
            setPaginacion(response.data.objeto);
        }).catch(error => {

        });
    }

    const validarFormulario = () => {
        let errores = {};
        if (servicioObjetos.esObjetoVacio(fechaIncial))
            errores.fechaIncial = "La fecha inicial es requerida";
        if (servicioObjetos.esObjetoVacio(fechaFinal))
            errores.fechaFinal = "La fecha final es requerida";
        return errores;
    }

    const columnaFecha = (rowData, column) => {
        return servicioFormatos.formatearFecha(rowData.fecha);
    }

    const cambiaPagina = (event) => {
        asignarRestricciones();
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        setInicio(event.first);
        realizarBusquedaHttp();
    }

    const asignarRestricciones = () => {
        let laFechaInicial = servicioFormatos.formatearFechaString(fechaIncial);
        let laFechaFinal = servicioFormatos.formatearFechaString(fechaFinal).replace('00:00:00', '23:59:59');
        paginacion.join = JOIN_INICIAL;
        paginacion.restriccionesDinamicas = [];
        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: 'between',
            nombrePropiedad: 'fechaMovimientoDate',
            valorPropiedad: null,
            fechaIncialBetween: laFechaInicial,
            fechaFinalBetween: laFechaFinal
        });
        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: 'in',
            nombrePropiedad: 'alias_ttUsuario.id',
            valorPropiedad: null,
            fechaIncialBetween: null,
            fechaFinalBetween: null,
            coleccionIn:usuarios
        });

        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: 'eq',
            nombrePropiedad: 'alias_ttLoteSolicitudIdse.tipo',
            valorPropiedad: 0,
            fechaIncialBetween: null,
            fechaFinalBetween: null,
            coleccionIn:usuarios
        });

        
    }

    const descargaExcel = () => {
        asignarRestricciones();
        paginacion.numeroPagina = 0;
        servicioArchivos.descargaArchivo('/movimientos/descargar_excel.json', paginacion, this);
    }

    const header = <div className="p-clearfix" style={{ 'lineHeight': '1.87em' }}>Detalle de movimientos {!servicioObjetos.esObjetoVacio(paginacion.datos) && <Button label="Descargar excel" icon="pi-md-cloud-download" className="p-button-warning" onClick={descargaExcel} style={{ 'float': 'right' }} />}</div>;

    return (
        !servicioObjetos.esObjetoVacio(usuarios) ?
            <div>
                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">* Fecha Inicial:</div>
                        <div className="p-col-12 p-md-2">
                            <Calendar appendTo={document.body} dateFormat={FORMATO_FECHA_CALENDAR} name="fechaIncial" value={fechaIncial || ""} className={errores.fechaInicial ? "p-error" : ""} onChange={e => { setFechaIncial(e.value) }} locale={CALENDARIO_ES_MX} />
                            {errores.fechaIncial ? <div><Message severity="error" text={errores.fechaIncial} /></div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">* Fecha Final:</div>
                        <div className="p-col-12 p-md-2">
                            <Calendar appendTo={document.body} dateFormat={FORMATO_FECHA_CALENDAR} name="fechaFinal" value={fechaFinal || ""} className={errores.fechaFinal ? "p-error" : ""} onChange={e => { setFechaFinal(e.value) }} locale={CALENDARIO_ES_MX} />
                            {errores.fechaFinal ? <div><Message severity="error" text={errores.fechaFinal} /></div> : null}
                        </div>

                        <div className="p-col-12 p-md-2">
                            <Button label="Buscar" icon="pi-md-search" onClick={buscarDetalle} />
                        </div>
                    </div>
                </div>
                <div className="card">
                    <DataTable header={header} value={paginacion.datos} responsive={true}
                        resizableColumns={true} autoLayout={true} scrollable={true} scrollHeight="250px">
                        <Column field="registroPatronal" header="Registro Patronal" />
                        <Column field="nombre" header="Nombre" />
                        <Column field="primerApellido" header="Apellido Paterno" />
                        <Column field="segundoApellido" header="Apellido Materno" />
                        <Column field="numeroSeguridadSocial" header="Nss" />
                        <Column field="curp" header="Curp" />
                        <Column body={columnaFecha} header="Fecha" />
                    </DataTable>
                    <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate={"Total: " + paginacion.registrosTotales + ", Página ({currentPage} de {totalPages})"} />
                </div>
            </div>
            : null
    );
}